import { API_URL, API_USER_URL } from '@/env';
import { message } from 'antd';

const API_USE = API_URL || '';

async function setRevenue_amount(amount: number, input_date: Date, rm_team?: number): Promise<any> {
    const token = localStorage.getItem('token') || '';
    if (!token) {
        throw new Error('No authentication token found');
    }

    try {
        const formattedDate = input_date.toISOString().split('T')[0];
        const response = await fetch(`${API_USE}/api/v1/be/admin/revenue/distribute`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                input_date: formattedDate,
                revenue_amount: amount,
                rm_team: rm_team || 0
            })
        });
        if (!response.ok) {
            message.error('Error setting revenue amount');
            throw new Error('Failed to set revenue amount');
        }
        message.success('Revenue amount set successfully');
        return await response.json();
    } catch (error) {
        message.error('Failed to set revenue amount' + (error instanceof Error ? `: ${error.message}` : ''));
        throw error;
    }
}

export { setRevenue_amount };